import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider } from '@ibk/shared-translation';
import { OperatorDrawerNavs } from '@ibk/shared-types';
import { sharedLayoutTranslations } from '../../../../translations';
import { OperatorsList } from '../../components/OperatorsList';
import { useOperatorsList } from '../../hooks/useOperatorList';
const OperatorDrawerHome = ({ ...props }) => {
    const { operatorsList, isLoading, isRefetching, deleteOperator, confirmationModal } = useOperatorsList();
    return (_jsxs(TranslationProvider, { translations: sharedLayoutTranslations, defaultLanguage: 'pt-BR', children: [_jsx(OperatorsList, { operatorsList: operatorsList, isLoading: isLoading, isRefetching: isRefetching, onDeleteOperator: deleteOperator, goToRegister: () => props.handleGoTo(OperatorDrawerNavs.REGISTER_TYPE) }), confirmationModal] }));
};
export default OperatorDrawerHome;
